export const REVIEW_MODES = [
  'comments',
  'paragraph_comments',
  'full_document_comments',
  'mouse_selection_comments',
] as const

export type ReviewMode = (typeof REVIEW_MODES)[number]

export function isReviewMode(value: string | null | undefined): value is ReviewMode {
  return REVIEW_MODES.includes(value as ReviewMode)
}

export function resolveReviewModeFromPrompt(dto: {
  review_mode?: string | null
  is_qc_prompt?: boolean | null
}): ReviewMode | null {
  if (dto.review_mode && isReviewMode(dto.review_mode)) {
    return dto.review_mode
  }
  if (dto.is_qc_prompt) {
    return 'mouse_selection_comments'
  }
  return null
}

/** Dual-write shim for chat requests during BE migration. Remove after BE #142 is live. */
export function buildChatReviewRequestFields(reviewMode: ReviewMode | null): {
  review_mode?: ReviewMode
  response_format?: string
} {
  if (!reviewMode) {
    return {}
  }
  return {
    review_mode: reviewMode,
    response_format: 'comments',
  }
}

/** Dual-write shim for prompt create during BE migration. Remove after BE #142 is live. */
export function buildCreatePromptReviewFields(reviewMode: ReviewMode | null | undefined): {
  review_mode?: ReviewMode
  is_qc_prompt?: boolean
} {
  if (!reviewMode) {
    return {}
  }

  return {
    review_mode: reviewMode,
    ...(reviewMode === 'mouse_selection_comments' ? { is_qc_prompt: true } : {}),
  }
}
